import { FC } from "react";

export type TabPanelHeaderProps = {
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
};

export const TabPanelHeader: FC<TabPanelHeaderProps> = ({ title, description }) => {
  return (
    <div className="cds--data-table-header !bg-transparent">
      {title && <h4 className="cds--data-table-header__title">{title}</h4>}
      {description && <p className="cds--data-table-header__description">{description}</p>}
    </div>
  );
};
